/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import { Card, Col, Container, Row, Table } from 'react-bootstrap'
import { Link, useLocation } from 'react-router-dom'

function SlotLocation() {
  const { pathname } = useLocation()
  const headMenu = pathname.split('/')[1]
  const poHeadMenu = pathname.split('/')[2]
  const routeValue = `${headMenu}/${poHeadMenu}`
  const headerTitleStyle = {
    color: 'var(--primary-orange)',
    fontSize: '24px',
    fontWeight: '600'
  }

  const cardStyle = {
    border: 'none',
    boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
    borderRadius: '12px',
    padding: '1.5rem',
    marginBottom: '1.5rem',
    backgroundColor: '#fff'
  }

  const tableHeaderStyle = {
    fontSize: '14px',
    fontWeight: '600',
    color: '#333333',
    letterSpacing: '0.5px',
    backgroundColor: '#f8f9fa',
    borderBottom: '2px solid #e9ecef'
  }
  const [item, setItem] = useState([])
  const { state } = useLocation()

  useEffect(() => {
    const { slotLocations, batch } = state
    const slotLocation = slotLocations.find(
      (value) => value.item_batch === batch
    )
    setItem(slotLocation)
  }, [])

  return (
    <Container>
      <div className="d-flex align-items-center justify-content-between mt-3 mb-3">
        <div>
          <h4 style={headerTitleStyle}>Slot Location</h4>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item sj-item">
                <Link to={'/outbound/sj'} className="text-decoration-none">
                  <span className="text-muted">
                    {routeValue === 'outbound/history'
                      ? 'Outbound History'
                      : 'SJ List'}
                  </span>
                </Link>
              </li>
              <li className="breadcrumb-item sj-item">
                <Link
                  to={
                    routeValue === 'outbound/history'
                      ? `/outbound/history/detail/${encodeURIComponent(
                          state.sjCode
                        )}`
                      : `/outbound/sj/detail/${encodeURIComponent(
                          state.sjCode
                        )}`
                  }
                  className="text-decoration-none"
                >
                  <span className="text-muted">{state.sjCode}</span>
                </Link>
              </li>
              <li
                className="breadcrumb-item sj-item active fw-bold"
                aria-current="page"
                style={{ color: 'var(--primary-orange)' }}
              >
                SLOT LOCATION
              </li>
            </ol>
          </nav>
        </div>
      </div>

      <Card style={cardStyle}>
        <div className="d-flex flex-row justify-content-between mb-3">
          <h5 className="fw-bold text-uppercase" style={{ color: '#333' }}>
            List Item
          </h5>
          <h6 className="fw-bold text-uppercase mt-1 me-4 text-secondary">
            <span className="text-success">{item?.available_qty}</span>
            <span> / </span>
            <span className="fw-bold text-dark">{item?.need_qty} Pack</span>
          </h6>
        </div>
        <Row>
          <Col md={12}>
            <Table hover responsive style={{ fontSize: '12px' }}>
              <thead style={{ backgroundColor: '#f8f9fa' }}>
                <tr>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    No
                  </th>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    Item Code - Name
                  </th>
                  <th
                    className="p-2 align-middle text-center"
                    style={tableHeaderStyle}
                  >
                    Item Alias
                  </th>
                  <th
                    className="p-2 align-middle text-center"
                    style={tableHeaderStyle}
                  >
                    Batch
                  </th>
                  <th
                    className="p-2 align-middle text-center"
                    style={tableHeaderStyle}
                  >
                    Total Pack
                  </th>
                  <th
                    className="p-2 align-middle text-end"
                    style={tableHeaderStyle}
                  >
                    Slot
                  </th>
                </tr>
              </thead>
              <tbody>
                {item?.items?.length === 0 && (
                  <tr>
                    <td
                      colSpan={6}
                      className="fw-bold text-center py-3 text-muted"
                    >
                      No Data
                    </td>
                  </tr>
                )}
                {item?.items?.length > 0 &&
                  item?.items.map((data, i) => (
                    <tr key={i}>
                      <td className="p-2 align-middle">{i + 1}</td>
                      <td className="p-2 align-middle">
                        {data?.item_code} - {data?.item_name}
                      </td>
                      <td className="p-2 align-middle text-center">
                        {data?.item_alias ?? '-'}
                      </td>
                      <td className="p-2 align-middle text-center">
                        {data?.batch ?? '-'}
                      </td>
                      <td className="p-2 align-middle text-center">
                        {data?.qty} {data?.uom_pack}
                      </td>
                      <td className="p-2 align-middle text-end text-primary fw-bold">
                        {data?.location}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      </Card>
    </Container>
  )
}

export default SlotLocation
